export default "__VITE_ASSET__BBF4Lfwf__"